import {useCallback, useEffect, useState} from 'react'
import {useBasketStore, useGlobalStore} from '../store/hooks/useStore'

export const useBaglessStores = (shouldFetch = false) => {
  const basketStore = useBasketStore()
  const [baglessEnabled, setBaglessEnabled] = useState<boolean>(false)
  const [baglessStoresExcluded, setBaglessStoresExcluded] = useState<string[]>([])
  const {customSitePreferences, getCustomSitePreferenceById} = useGlobalStore()


  const isBaglessStore = useCallback(
    (id: string) => {
      return baglessEnabled && !baglessStoresExcluded?.includes(id)
    },
    [baglessStoresExcluded],
  )

  const isCurrentStoreBagless = useCallback(() => {
    if (basketStore.currentDeliveryStoreId == null) {
      return false
    }

    return baglessEnabled && !baglessStoresExcluded?.includes(basketStore.currentDeliveryStoreId)
  }, [basketStore, baglessStoresExcluded])

  useEffect(() => {
    if (shouldFetch) {
      ;(async function () {
        await getCustomSitePreferenceById('baglessStoresExcluded')
        await getCustomSitePreferenceById('baglessEnabled')
      })()
    }
    const ids = customSitePreferences['baglessStoresExcluded'] as string[]
    setBaglessEnabled(customSitePreferences['baglessEnabled'] === true)
    setBaglessStoresExcluded(ids)
  }, [shouldFetch])

  const currentStoreMessage = isCurrentStoreBagless()
    ? 'Picking & Packing'
    : 'Bags, Picking & Packing'

  return {
    baglessStoresExcluded,
    isBaglessStore,
    isCurrentStoreBagless: isCurrentStoreBagless(),
    currentStoreMessage,
  }
}
